import React from 'react'
import { Loader } from 'semantic-ui-react'
const Spinner = () => <Loader active inline='centered' className='darkLoader'/>
export default Spinner
